import React, { useState, useEffect } from 'react';
import { Outlet, useLocation, Link } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';
import { Toaster } from './ui/sonner';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const AdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  // Chiudi sidebar quando cambia pagina (mobile/tablet)
  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  // Chiudi sidebar su resize a desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1024) setSidebarOpen(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="app-container">
      {/* Mobile/Tablet top bar */}
      <div className="mobile-topbar" data-testid="mobile-topbar">
        <Button 
          variant="ghost" 
          size="sm" 
          onClick={() => setSidebarOpen(!sidebarOpen)}
          className="text-white hover:bg-slate-800"
          data-testid="sidebar-toggle"
        >
          {sidebarOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </Button>
        <Link to="/admin" aria-label="Vai alla Dashboard" data-testid="mobile-topbar-logo" className="flex items-center hover:opacity-80 transition-opacity">
          <img src="/logo-white-cropped.svg" alt="SemplificApp" className="h-7" />
        </Link>
        <div className="w-10" /> {/* Spacer for centering */}
      </div>

      {/* Overlay */}
      {sidebarOpen && (
        <div 
          className="sidebar-overlay" 
          onClick={() => setSidebarOpen(false)}
          data-testid="sidebar-overlay"
        />
      )}

      <AdminSidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <main className="main-content">
        <Outlet />
      </main>
      <Toaster richColors position="top-right" />
    </div>
  );
};

export default AdminLayout;
